module.exports = __webpack_public_path__ + "static/media/_MIC2611.image.06949a99.png";